export const sxTopoCriarEncomenda = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
}
